import { useState } from "react";
import Box from "@mui/material/Box";
import { useSelector } from "react-redux";
import checkIfEnable from "../../../utils/checkIfEnable";
import ServiceIDByLabel from "../../../services/ServiceIDByLabel";
import ICONS from "../../../assets/Icons";
import SVGComponent from "../../_utils/SVGComponent";

const MenuItemCardmobile = ({ icon, label, labelm, labela }) => {
  const services_list = useSelector((state) => state.refreshToken.services);
  const [showExandArrow, setShowExpandArrow] = useState(false);

  return (
    <Box
      onMouseLeave={() => setShowExpandArrow(false)}
      onMouseEnter={() => setShowExpandArrow(true)}
      sx={[
        checkIfEnable(ServiceIDByLabel, label, labelm, labela, services_list) &&
          {},
        !checkIfEnable(
          ServiceIDByLabel,
          label,
          labelm,
          labela,
          services_list,
        ) && {},
      ]}
    >
      <div className="flex justify-between items-center w-full pb-padding-sm pt-padding-base px-padding-md ">
        <div className="w-full flex items-center justify-start">
          <img
            src={icon}
            alt=""
            className="w-icon-lg h-icon-lg"
          />
          <span className="ml-margin-sm text-text-primary text-xs">
            {labelm + " " + labela}
          </span>
        </div>
        <SVGComponent
          url={ICONS?.ARROW_RIGHT_WHITE}
          height={"var(--icon-xs)"}
          width={"var(--icon-xs)"}
          color={"var(--text-primary)"}
        />
      </div>
    </Box>
  );
};

export default MenuItemCardmobile;
